module.exports = __webpack_public_path__ + "img/boy_010030.418ebe95.png";